import {OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

export abstract class GenericMenu implements OnInit {

  @Input() shrinkMode : boolean = false;
  @Input() expanded   : boolean = true;

  
  constructor(
    protected router              : Router,
    protected activatedRoute      : ActivatedRoute,
  ) { }
  
  ngOnInit() {
  }

  navigateTo(segment : string){
    this.router.navigate([segment], {relativeTo : this.activatedRoute});
  }   

  select(itemId : string){
    
  }

}
